// @generated
import { PapiNcMessage } from '@wix/da-papi-types';

// source: /drawer and /bucket endpoints
const messages: PapiNcMessage[] = [
  {
    messageId: 'id:nc:6:18468580:4955310272:313707851',
    type: 'nc.comment_mentions_deviation',
    messageClass: 'class.mention.deviation',
    bucket: 'bucket.mention',
    folderId: 34,
    orphaned: false,
    ts: '2021-12-07T05:21:54-0800',
    isNew: true,
    originator: {
      userId: 18468580,
      useridUuid: '0a8ace1e-a5d0-45cc-94a5-b8630c37fb8a',
      username: 'inazar',
      usericon: 'https://a.deviantart.net/avatars-big/i/n/inazar.png?11',
      type: 'admin',
      isWatching: false,
      isSubscribed: false,
      isNewDeviant: false,
    },
    messageData: {
      dataKey: 'comment_mentions_deviation',
      commentMentionsDeviation: {
        mentioner: {
          commentId: 4955310272,
          typeId: 1,
          itemId: 883924185,
          parentId: null,
          posted: '2021-12-07T05:21:54-0800',
          likes: 0,
          replies: 1,
          textContent: {
            excerpt: 'mention \n \nin a dev comment',
            html: {
              type: 'draft',
              markup:
                '{"blocks":[{"key":"foo","text":"mention ","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}},{"key":"c2415","text":" ","type":"atomic","depth":0,"inlineStyleRanges":[],"entityRanges":[{"offset":0,"length":1,"key":0}],"data":{}},{"key":"1svrl","text":"in a dev comment","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}}],"entityMap":{"0":{"type":"wix-draft-plugin-image","mutability":"IMMUTABLE","data":{"config":{"alignment":"center","size":"content","showTitle":true,"showDescription":true,"key":"c2415"},"data":{"deviationId":313707851,"type":"image","typeId":1,"url":"https://www.deviantart.lan/chris/art/Pacific-Coast-Highway-Photos-313707851","title":"Pacific Coast Highway Photos","isJournal":false,"isVideo":false,"isPurchasable":true,"isFavouritable":true,"publishedTime":"2012-07-09T19:47:17-0700","isShareable":true,"isCommentable":true,"isFavourited":false,"isDeleted":false,"isMature":false,"isDownloadable":false,"isAntisocial":false,"isBlocked":false,"isPublished":true,"isDailyDeviation":false,"hasPrivateComments":false,"author":{"userId":3,"useridUuid":"178e6afa-0f9b-4ef0-bb15-47dadfa0e470","username":"chris","usericon":"https://a.deviantart.net/avatars-big/c/h/chris.jpg?4","type":"admin","isWatching":false,"isSubscribed":false,"isNewDeviant":false},"media":{"baseUri":"https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/178e6afa-0f9b-4ef0-bb15-47dadfa0e470/d56ruiz-a65409ce-bc27-454f-bf1c-f9f181973048.jpg","prettyName":"pacific_coast_highway_photos_by_chris_d56ruiz","token":["eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7ImhlaWdodCI6Ijw9NjgzIiwicGF0aCI6IlwvZlwvMTc4ZTZhZmEtMGY5Yi00ZWYwLWJiMTUtNDdkYWRmYTBlNDcwXC9kNTZydWl6LWE2NTQwOWNlLWJjMjctNDU0Zi1iZjFjLWY5ZjE4MTk3MzA0OC5qcGciLCJ3aWR0aCI6Ijw9MTAyNCJ9XV0sImF1ZCI6WyJ1cm46c2VydmljZTppbWFnZS5vcGVyYXRpb25zIl19.d5CXSWMivKwoyOixdI9FJudAThJl2wXV0DdojlmVUXc"],"types":[{"t":"150","r":0,"c":"v1/fit/w_150,h_150,q_70,strp/<prettyName>-150.jpg","h":100,"w":150},{"t":"200H","r":0,"c":"v1/fill/w_300,h_200,q_70,strp/<prettyName>-200h.jpg","h":200,"w":300},{"t":"300W","r":0,"c":"v1/fit/w_300,h_683,q_70,strp/<prettyName>-300w.jpg","h":200,"w":300},{"t":"250T","r":0,"c":"v1/fill/w_375,h_250,q_70,strp/<prettyName>-250t.jpg","h":250,"w":375},{"t":"350T","r":0,"c":"v1/fill/w_525,h_350,q_70,strp/<prettyName>-350t.jpg","h":350,"w":525},{"t":"400T","r":0,"c":"v1/fill/w_600,h_400,q_70,strp/<prettyName>-400t.jpg","h":400,"w":600},{"t":"preview","r":0,"c":"v1/fill/w_1024,h_683,q_75,strp/<prettyName>-fullview.jpg","h":683,"w":1024,"f":6722544},{"t":"social_preview","r":0,"c":"v1/fill/w_1024,h_683,q_75,strp/<prettyName>-fullview.jpg","h":683,"w":1024},{"t":"fullview","r":0,"c":"v1/fill/w_1024,h_683,q_75,strp/<prettyName>-fullview.jpg","h":683,"w":1024,"f":6722544}]}}}}}}',
              features:
                '[{"type":"FIRST_IMAGE_FEATURE","data":{"deviation":{"deviationId":313707851,"type":"image","typeId":1,"url":"https:\\/\\/www.deviantart.lan\\/chris\\/art\\/Pacific-Coast-Highway-Photos-313707851","title":"Pacific Coast Highway Photos","isJournal":false,"isVideo":false,"isPurchasable":true,"isFavouritable":true,"publishedTime":"2012-07-09T19:47:17-0700","isShareable":true,"isCommentable":true,"isFavourited":false,"isDeleted":false,"isMature":false,"isDownloadable":false,"isAntisocial":false,"isBlocked":false,"isPublished":true,"isDailyDeviation":false,"hasPrivateComments":false,"author":{"userId":3,"useridUuid":"178e6afa-0f9b-4ef0-bb15-47dadfa0e470","username":"chris","usericon":"https:\\/\\/a.deviantart.net\\/avatars-big\\/c\\/h\\/chris.jpg?4","type":"admin","isWatching":false,"isSubscribed":false,"isNewDeviant":false},"media":{"baseUri":"https:\\/\\/images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com\\/f\\/178e6afa-0f9b-4ef0-bb15-47dadfa0e470\\/d56ruiz-a65409ce-bc27-454f-bf1c-f9f181973048.jpg","prettyName":"pacific_coast_highway_photos_by_chris_d56ruiz","token":["eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7ImhlaWdodCI6Ijw9NjgzIiwicGF0aCI6IlwvZlwvMTc4ZTZhZmEtMGY5Yi00ZWYwLWJiMTUtNDdkYWRmYTBlNDcwXC9kNTZydWl6LWE2NTQwOWNlLWJjMjctNDU0Zi1iZjFjLWY5ZjE4MTk3MzA0OC5qcGciLCJ3aWR0aCI6Ijw9MTAyNCJ9XV0sImF1ZCI6WyJ1cm46c2VydmljZTppbWFnZS5vcGVyYXRpb25zIl19.d5CXSWMivKwoyOixdI9FJudAThJl2wXV0DdojlmVUXc"],"types":[{"t":"150","r":0,"c":"v1\\/fit\\/w_150,h_150,q_70,strp\\/<prettyName>-150.jpg","h":100,"w":150},{"t":"200H","r":0,"c":"v1\\/fill\\/w_300,h_200,q_70,strp\\/<prettyName>-200h.jpg","h":200,"w":300},{"t":"300W","r":0,"c":"v1\\/fit\\/w_300,h_683,q_70,strp\\/<prettyName>-300w.jpg","h":200,"w":300},{"t":"250T","r":0,"c":"v1\\/fill\\/w_375,h_250,q_70,strp\\/<prettyName>-250t.jpg","h":250,"w":375},{"t":"350T","r":0,"c":"v1\\/fill\\/w_525,h_350,q_70,strp\\/<prettyName>-350t.jpg","h":350,"w":525},{"t":"400T","r":0,"c":"v1\\/fill\\/w_600,h_400,q_70,strp\\/<prettyName>-400t.jpg","h":400,"w":600},{"t":"preview","r":0,"c":"v1\\/fill\\/w_1024,h_683,q_75,strp\\/<prettyName>-fullview.jpg","h":683,"w":1024,"f":6722544},{"t":"social_preview","r":0,"c":"v1\\/fill\\/w_1024,h_683,q_75,strp\\/<prettyName>-fullview.jpg","h":683,"w":1024},{"t":"fullview","r":0,"c":"v1\\/fill\\/w_1024,h_683,q_75,strp\\/<prettyName>-fullview.jpg","h":683,"w":1024,"f":6722544}]}}}},{"type":"IS_EMPTY_FEATURE","data":{"isEmpty":false}},{"type":"MEDIA_COUNT_FEATURE","data":{"emoji":0,"emotes":0,"images":1,"mentions":0,"video":0,"previews":0}},{"type":"WORD_COUNT_FEATURE","data":{"words":5,"chars":25}}]',
            },
          },
          user: {
            userId: 18468580,
            useridUuid: '0a8ace1e-a5d0-45cc-94a5-b8630c37fb8a',
            username: 'inazar',
            usericon: 'https://a.deviantart.net/avatars-big/i/n/inazar.png?11',
            type: 'admin',
            isWatching: false,
            isSubscribed: false,
            isNewDeviant: false,
          },
          commentUrl: 'https://www.deviantart.lan/comments/1/883924185/4955310272',
          commentable: {
            dataKey: 'deviation',
            deviation: {
              deviationId: 883924185,
              type: 'image',
              typeId: 1,
              url: 'https://www.deviantart.lan/inazar/art/Kenopsia-883924185',
              title: 'Kenopsia',
              isJournal: false,
              isVideo: false,
              isPurchasable: false,
              isFavouritable: true,
              publishedTime: '2021-06-27T08:01:39-0700',
              isTextEditable: false,
              legacyTextEditUrl: null,
              isShareable: true,
              isCommentable: true,
              isFavourited: false,
              isDeleted: false,
              isMature: false,
              isDownloadable: true,
              isAntisocial: false,
              isBlocked: false,
              isPublished: true,
              isDailyDeviation: false,
              hasPrivateComments: false,
              blockReasons: [],
              author: {
                userId: 18468580,
                useridUuid: '0a8ace1e-a5d0-45cc-94a5-b8630c37fb8a',
                username: 'inazar',
                usericon: 'https://a.deviantart.net/avatars-big/i/n/inazar.png?11',
                type: 'admin',
                isWatching: false,
                isSubscribed: false,
                isNewDeviant: false,
              },
              stats: { comments: 0, favourites: 0 },
              media: {
                baseUri:
                  'https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/0a8ace1e-a5d0-45cc-94a5-b8630c37fb8a/dem9k9l-fb6f4e04-3bd0-41fa-92a1-e18b7e7c6b9c.jpg',
                prettyName: 'kenopsia_by_inazar_dem9k9l',
                token: [
                  'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7ImhlaWdodCI6Ijw9OTYwIiwicGF0aCI6IlwvZlwvMGE4YWNlMWUtYTVkMC00NWNjLTk0YTUtYjg2MzBjMzdmYjhhXC9kZW05azlsLWZiNmY0ZTA0LTNiZDAtNDFmYS05MmExLWUxOGI3ZTdjNmI5Yy5qcGciLCJ3aWR0aCI6Ijw9MTI4MCJ9XV0sImF1ZCI6WyJ1cm46c2VydmljZTppbWFnZS5vcGVyYXRpb25zIl19.OBAa88EjmRC4T2kTBNgnt6BbW5GyiGXZUXD4G8Z1Xuc',
                ],
                types: [
                  {
                    t: '150',
                    r: 0,
                    c: 'v1/fit/w_150,h_150,q_70,strp/<prettyName>-150.jpg',
                    h: 113,
                    w: 150,
                  },
                  {
                    t: '200H',
                    r: 0,
                    c: 'v1/fill/w_267,h_200,q_70,strp/<prettyName>-200h.jpg',
                    h: 200,
                    w: 267,
                  },
                  {
                    t: '300W',
                    r: 0,
                    c: 'v1/fit/w_300,h_900,q_70,strp/<prettyName>-300w.jpg',
                    h: 225,
                    w: 300,
                  },
                  {
                    t: '250T',
                    r: 0,
                    c: 'v1/fill/w_333,h_250,q_70,strp/<prettyName>-250t.jpg',
                    h: 250,
                    w: 333,
                  },
                  {
                    t: '350T',
                    r: 0,
                    c: 'v1/fill/w_467,h_350,q_70,strp/<prettyName>-350t.jpg',
                    h: 350,
                    w: 467,
                  },
                  {
                    t: '400T',
                    r: 0,
                    c: 'v1/fill/w_533,h_400,q_70,strp/<prettyName>-400t.jpg',
                    h: 400,
                    w: 533,
                  },
                  {
                    t: 'preview',
                    r: 0,
                    c: 'v1/fill/w_1032,h_774,q_70,strp/<prettyName>-pre.jpg',
                    h: 774,
                    w: 1032,
                    f: 1239693,
                  },
                  {
                    t: 'social_preview',
                    r: 0,
                    c: 'v1/fill/w_1032,h_774,q_70,strp/<prettyName>-pre.jpg',
                    h: 774,
                    w: 1032,
                  },
                  {
                    t: 'fullview',
                    r: 0,
                    c: 'v1/fill/w_1280,h_960,q_75,strp/<prettyName>-fullview.jpg',
                    h: 960,
                    w: 1280,
                    f: 1239693,
                  },
                ],
              },
            },
          },
        },
        mentioned: {
          deviationId: 313707851,
          type: 'image',
          typeId: 1,
          url: 'https://www.deviantart.lan/chris/art/Pacific-Coast-Highway-Photos-313707851',
          title: 'Pacific Coast Highway Photos',
          isJournal: false,
          isVideo: false,
          isPurchasable: true,
          isFavouritable: false,
          publishedTime: '2012-07-09T19:47:17-0700',
          isTextEditable: false,
          legacyTextEditUrl: null,
          isShareable: true,
          isCommentable: true,
          isFavourited: false,
          isDeleted: false,
          isMature: false,
          isDownloadable: false,
          isAntisocial: false,
          isBlocked: false,
          isPublished: true,
          isDailyDeviation: false,
          hasPrivateComments: false,
          blockReasons: [],
          author: {
            userId: 3,
            useridUuid: '178e6afa-0f9b-4ef0-bb15-47dadfa0e470',
            username: 'chris',
            usericon: 'https://a.deviantart.net/avatars-big/c/h/chris.jpg?4',
            type: 'admin',
            isWatching: false,
            isNewDeviant: false,
          },
          stats: { comments: 0, favourites: 0 },
          media: {
            baseUri:
              'https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/178e6afa-0f9b-4ef0-bb15-47dadfa0e470/d56ruiz-a65409ce-bc27-454f-bf1c-f9f181973048.jpg',
            prettyName: 'pacific_coast_highway_photos_by_chris_d56ruiz',
            token: [
              'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7ImhlaWdodCI6Ijw9NjgzIiwicGF0aCI6IlwvZlwvMTc4ZTZhZmEtMGY5Yi00ZWYwLWJiMTUtNDdkYWRmYTBlNDcwXC9kNTZydWl6LWE2NTQwOWNlLWJjMjctNDU0Zi1iZjFjLWY5ZjE4MTk3MzA0OC5qcGciLCJ3aWR0aCI6Ijw9MTAyNCJ9XV0sImF1ZCI6WyJ1cm46c2VydmljZTppbWFnZS5vcGVyYXRpb25zIl19.d5CXSWMivKwoyOixdI9FJudAThJl2wXV0DdojlmVUXc',
            ],
            types: [
              {
                t: '150',
                r: 0,
                c: 'v1/fit/w_150,h_150,q_70,strp/<prettyName>-150.jpg',
                h: 100,
                w: 150,
              },
              {
                t: '200H',
                r: 0,
                c: 'v1/fill/w_300,h_200,q_70,strp/<prettyName>-200h.jpg',
                h: 200,
                w: 300,
              },
              {
                t: '300W',
                r: 0,
                c: 'v1/fit/w_300,h_683,q_70,strp/<prettyName>-300w.jpg',
                h: 200,
                w: 300,
              },
              {
                t: '250T',
                r: 0,
                c: 'v1/fill/w_375,h_250,q_70,strp/<prettyName>-250t.jpg',
                h: 250,
                w: 375,
              },
              {
                t: '350T',
                r: 0,
                c: 'v1/fill/w_525,h_350,q_70,strp/<prettyName>-350t.jpg',
                h: 350,
                w: 525,
              },
              {
                t: '400T',
                r: 0,
                c: 'v1/fill/w_600,h_400,q_70,strp/<prettyName>-400t.jpg',
                h: 400,
                w: 600,
              },
              {
                t: 'preview',
                r: 0,
                c: 'v1/fill/w_1024,h_683,q_75,strp/<prettyName>-fullview.jpg',
                h: 683,
                w: 1024,
                f: 6722544,
              },
              {
                t: 'social_preview',
                r: 0,
                c: 'v1/fill/w_1024,h_683,q_75,strp/<prettyName>-fullview.jpg',
                h: 683,
                w: 1024,
              },
              {
                t: 'fullview',
                r: 0,
                c: 'v1/fill/w_1024,h_683,q_75,strp/<prettyName>-fullview.jpg',
                h: 683,
                w: 1024,
                f: 6722544,
              },
            ],
          },
        },
      },
    },
  },
  {
    messageId: 'id:nc:6:18468580:4955310271:313707851',
    type: 'nc.comment_mentions_deviation',
    messageClass: 'class.mention.deviation',
    bucket: 'bucket.mention',
    folderId: 34,
    orphaned: false,
    ts: '2021-12-07T05:21:40-0800',
    isNew: true,
    originator: {
      userId: 18468580,
      useridUuid: '0a8ace1e-a5d0-45cc-94a5-b8630c37fb8a',
      username: 'inazar',
      usericon: 'https://a.deviantart.net/avatars-big/i/n/inazar.png?11',
      type: 'admin',
      isWatching: false,
      isSubscribed: false,
      isNewDeviant: false,
    },
    messageData: {
      dataKey: 'comment_mentions_deviation',
      commentMentionsDeviation: {
        mentioner: {
          commentId: 4955310271,
          typeId: 1,
          itemId: 881239537,
          parentId: null,
          replies: 1,
          likes: 0,
          posted: '2021-12-07T05:21:40-0800',
          textContent: {
            excerpt: 'mention \n \nin a journal comment',
            html: {
              type: 'draft',
              markup:
                '{"blocks":[{"key":"foo","text":"mention ","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}},{"key":"528ov","text":" ","type":"atomic","depth":0,"inlineStyleRanges":[],"entityRanges":[{"offset":0,"length":1,"key":0}],"data":{}},{"key":"3ko4h","text":"in a journal comment","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}}],"entityMap":{"0":{"type":"wix-draft-plugin-image","mutability":"IMMUTABLE","data":{"config":{"alignment":"center","size":"content","showTitle":true,"showDescription":true,"key":"528ov"},"data":{"deviationId":313707851,"type":"image","typeId":1,"url":"https://www.deviantart.lan/chris/art/Pacific-Coast-Highway-Photos-313707851","title":"Pacific Coast Highway Photos","isJournal":false,"isVideo":false,"isPurchasable":true,"isFavouritable":true,"publishedTime":"2012-07-09T19:47:17-0700","isShareable":true,"isCommentable":true,"isFavourited":false,"isDeleted":false,"isMature":false,"isDownloadable":false,"isAntisocial":false,"isBlocked":false,"isPublished":true,"isDailyDeviation":false,"hasPrivateComments":false,"author":{"userId":3,"useridUuid":"178e6afa-0f9b-4ef0-bb15-47dadfa0e470","username":"chris","usericon":"https://a.deviantart.net/avatars-big/c/h/chris.jpg?4","type":"admin","isWatching":false,"isSubscribed":false,"isNewDeviant":false},"media":{"baseUri":"https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/178e6afa-0f9b-4ef0-bb15-47dadfa0e470/d56ruiz-a65409ce-bc27-454f-bf1c-f9f181973048.jpg","prettyName":"pacific_coast_highway_photos_by_chris_d56ruiz","token":["eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7ImhlaWdodCI6Ijw9NjgzIiwicGF0aCI6IlwvZlwvMTc4ZTZhZmEtMGY5Yi00ZWYwLWJiMTUtNDdkYWRmYTBlNDcwXC9kNTZydWl6LWE2NTQwOWNlLWJjMjctNDU0Zi1iZjFjLWY5ZjE4MTk3MzA0OC5qcGciLCJ3aWR0aCI6Ijw9MTAyNCJ9XV0sImF1ZCI6WyJ1cm46c2VydmljZTppbWFnZS5vcGVyYXRpb25zIl19.d5CXSWMivKwoyOixdI9FJudAThJl2wXV0DdojlmVUXc"],"types":[{"t":"150","r":0,"c":"v1/fit/w_150,h_150,q_70,strp/<prettyName>-150.jpg","h":100,"w":150},{"t":"200H","r":0,"c":"v1/fill/w_300,h_200,q_70,strp/<prettyName>-200h.jpg","h":200,"w":300},{"t":"300W","r":0,"c":"v1/fit/w_300,h_683,q_70,strp/<prettyName>-300w.jpg","h":200,"w":300},{"t":"250T","r":0,"c":"v1/fill/w_375,h_250,q_70,strp/<prettyName>-250t.jpg","h":250,"w":375},{"t":"350T","r":0,"c":"v1/fill/w_525,h_350,q_70,strp/<prettyName>-350t.jpg","h":350,"w":525},{"t":"400T","r":0,"c":"v1/fill/w_600,h_400,q_70,strp/<prettyName>-400t.jpg","h":400,"w":600},{"t":"preview","r":0,"c":"v1/fill/w_1024,h_683,q_75,strp/<prettyName>-fullview.jpg","h":683,"w":1024,"f":6722544},{"t":"social_preview","r":0,"c":"v1/fill/w_1024,h_683,q_75,strp/<prettyName>-fullview.jpg","h":683,"w":1024},{"t":"fullview","r":0,"c":"v1/fill/w_1024,h_683,q_75,strp/<prettyName>-fullview.jpg","h":683,"w":1024,"f":6722544}]}}}}}}',
              features:
                '[{"type":"FIRST_IMAGE_FEATURE","data":{"deviation":{"deviationId":313707851,"type":"image","typeId":1,"url":"https:\\/\\/www.deviantart.lan\\/chris\\/art\\/Pacific-Coast-Highway-Photos-313707851","title":"Pacific Coast Highway Photos","isJournal":false,"isVideo":false,"isPurchasable":true,"isFavouritable":true,"publishedTime":"2012-07-09T19:47:17-0700","isShareable":true,"isCommentable":true,"isFavourited":false,"isDeleted":false,"isMature":false,"isDownloadable":false,"isAntisocial":false,"isBlocked":false,"isPublished":true,"isDailyDeviation":false,"hasPrivateComments":false,"author":{"userId":3,"useridUuid":"178e6afa-0f9b-4ef0-bb15-47dadfa0e470","username":"chris","usericon":"https:\\/\\/a.deviantart.net\\/avatars-big\\/c\\/h\\/chris.jpg?4","type":"admin","isWatching":false,"isSubscribed":false,"isNewDeviant":false},"media":{"baseUri":"https:\\/\\/images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com\\/f\\/178e6afa-0f9b-4ef0-bb15-47dadfa0e470\\/d56ruiz-a65409ce-bc27-454f-bf1c-f9f181973048.jpg","prettyName":"pacific_coast_highway_photos_by_chris_d56ruiz","token":["eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7ImhlaWdodCI6Ijw9NjgzIiwicGF0aCI6IlwvZlwvMTc4ZTZhZmEtMGY5Yi00ZWYwLWJiMTUtNDdkYWRmYTBlNDcwXC9kNTZydWl6LWE2NTQwOWNlLWJjMjctNDU0Zi1iZjFjLWY5ZjE4MTk3MzA0OC5qcGciLCJ3aWR0aCI6Ijw9MTAyNCJ9XV0sImF1ZCI6WyJ1cm46c2VydmljZTppbWFnZS5vcGVyYXRpb25zIl19.d5CXSWMivKwoyOixdI9FJudAThJl2wXV0DdojlmVUXc"],"types":[{"t":"150","r":0,"c":"v1\\/fit\\/w_150,h_150,q_70,strp\\/<prettyName>-150.jpg","h":100,"w":150},{"t":"200H","r":0,"c":"v1\\/fill\\/w_300,h_200,q_70,strp\\/<prettyName>-200h.jpg","h":200,"w":300},{"t":"300W","r":0,"c":"v1\\/fit\\/w_300,h_683,q_70,strp\\/<prettyName>-300w.jpg","h":200,"w":300},{"t":"250T","r":0,"c":"v1\\/fill\\/w_375,h_250,q_70,strp\\/<prettyName>-250t.jpg","h":250,"w":375},{"t":"350T","r":0,"c":"v1\\/fill\\/w_525,h_350,q_70,strp\\/<prettyName>-350t.jpg","h":350,"w":525},{"t":"400T","r":0,"c":"v1\\/fill\\/w_600,h_400,q_70,strp\\/<prettyName>-400t.jpg","h":400,"w":600},{"t":"preview","r":0,"c":"v1\\/fill\\/w_1024,h_683,q_75,strp\\/<prettyName>-fullview.jpg","h":683,"w":1024,"f":6722544},{"t":"social_preview","r":0,"c":"v1\\/fill\\/w_1024,h_683,q_75,strp\\/<prettyName>-fullview.jpg","h":683,"w":1024},{"t":"fullview","r":0,"c":"v1\\/fill\\/w_1024,h_683,q_75,strp\\/<prettyName>-fullview.jpg","h":683,"w":1024,"f":6722544}]}}}},{"type":"IS_EMPTY_FEATURE","data":{"isEmpty":false}},{"type":"MEDIA_COUNT_FEATURE","data":{"emoji":0,"emotes":0,"images":1,"mentions":0,"video":0,"previews":0}},{"type":"WORD_COUNT_FEATURE","data":{"words":5,"chars":29}}]',
            },
          },
          user: {
            userId: 18468580,
            useridUuid: '0a8ace1e-a5d0-45cc-94a5-b8630c37fb8a',
            username: 'inazar',
            usericon: 'https://a.deviantart.net/avatars-big/i/n/inazar.png?11',
            type: 'admin',
            isWatching: false,
            isSubscribed: false,
            isNewDeviant: false,
          },
          commentUrl: 'https://www.deviantart.lan/comments/1/881239537/4955310271',
          commentable: {
            dataKey: 'deviation',
            deviation: {
              deviationId: 881239537,
              type: 'journal',
              typeId: 5,
              url: 'https://www.deviantart.lan/inazar/journal/Anti-Cheat-Countermeasures-in-the-Holiday-Puzzle-881239537',
              title: 'Anti-Cheat Countermeasures in the Holiday Puzzle',
              isJournal: true,
              isVideo: false,
              isPurchasable: false,
              isFavouritable: true,
              publishedTime: '2021-06-09T12:09:21-0700',
              isTextEditable: true,
              legacyTextEditUrl: null,
              isShareable: true,
              isCommentable: true,
              isFavourited: false,
              isDeleted: false,
              isMature: false,
              isDownloadable: false,
              isAntisocial: false,
              isBlocked: false,
              isPublished: true,
              isDailyDeviation: false,
              hasPrivateComments: false,
              blockReasons: [],
              author: {
                userId: 18468580,
                useridUuid: '0a8ace1e-a5d0-45cc-94a5-b8630c37fb8a',
                username: 'inazar',
                usericon: 'https://a.deviantart.net/avatars-big/i/n/inazar.png?11',
                type: 'admin',
                isWatching: false,
                isSubscribed: false,
                isNewDeviant: false,
              },
              stats: { comments: 0, favourites: 0 },
              media: { types: [] },
              textContent: {
                excerpt:
                  'The following information has been declassified from the DeviantArt Code Archive, after the decommissioning of the Holiday Puzzle. Back in the mists of time (or "2011") DA\'s annual Holiday Extravaganza sale needed a little sprucing up, so we came up with the idea of a simple Threes-alike puzzle game: click on groups of three or more Christmas-themed items, and they\'d clear from the screen. Clear as much as you could, and the screen would refill as you moved up a level; cross a threshold with your final score, and get a discount code to use in the shop against prints and DevWear (yes, we once had merch too). As it turned out, the promise of a discount brought out some of the more devious deviants, and they started finding ways to get at the codes without going to the trouble of playing the game... Countermeasure I: Server-side Vouchers Very quickly we found out that an enterprising person, learning that this game provided discount codes, could simply read through the source code of',
                html: {
                  type: 'draft',
                  features:
                    '[{"type":"IS_EMPTY_FEATURE","data":{"isEmpty":false}},{"type":"WORD_COUNT_FEATURE","data":{"words":171,"chars":997}},{"type":"MEDIA_COUNT_FEATURE","data":{"emoji":0,"emotes":0,"images":3,"mentions":0,"video":0,"previews":0}}]',
                },
              },
            },
          },
        },
        mentioned: {
          deviationId: 313707851,
          type: 'image',
          typeId: 1,
          url: 'https://www.deviantart.lan/chris/art/Pacific-Coast-Highway-Photos-313707851',
          title: 'Pacific Coast Highway Photos',
          isJournal: false,
          isVideo: false,
          isPurchasable: true,
          isFavouritable: false,
          publishedTime: '2012-07-09T19:47:17-0700',
          isTextEditable: false,
          legacyTextEditUrl: null,
          isShareable: true,
          isCommentable: true,
          isFavourited: false,
          isDeleted: false,
          isMature: false,
          isDownloadable: false,
          isAntisocial: false,
          isBlocked: false,
          isPublished: true,
          isDailyDeviation: false,
          hasPrivateComments: false,
          blockReasons: [],
          author: {
            userId: 3,
            useridUuid: '178e6afa-0f9b-4ef0-bb15-47dadfa0e470',
            username: 'chris',
            usericon: 'https://a.deviantart.net/avatars-big/c/h/chris.jpg?4',
            type: 'admin',
            isWatching: false,
            isNewDeviant: false,
          },
          stats: { comments: 0, favourites: 0 },
          media: {
            baseUri:
              'https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/178e6afa-0f9b-4ef0-bb15-47dadfa0e470/d56ruiz-a65409ce-bc27-454f-bf1c-f9f181973048.jpg',
            prettyName: 'pacific_coast_highway_photos_by_chris_d56ruiz',
            token: [
              'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7ImhlaWdodCI6Ijw9NjgzIiwicGF0aCI6IlwvZlwvMTc4ZTZhZmEtMGY5Yi00ZWYwLWJiMTUtNDdkYWRmYTBlNDcwXC9kNTZydWl6LWE2NTQwOWNlLWJjMjctNDU0Zi1iZjFjLWY5ZjE4MTk3MzA0OC5qcGciLCJ3aWR0aCI6Ijw9MTAyNCJ9XV0sImF1ZCI6WyJ1cm46c2VydmljZTppbWFnZS5vcGVyYXRpb25zIl19.d5CXSWMivKwoyOixdI9FJudAThJl2wXV0DdojlmVUXc',
            ],
            types: [
              {
                t: '150',
                r: 0,
                c: 'v1/fit/w_150,h_150,q_70,strp/<prettyName>-150.jpg',
                h: 100,
                w: 150,
              },
              {
                t: '200H',
                r: 0,
                c: 'v1/fill/w_300,h_200,q_70,strp/<prettyName>-200h.jpg',
                h: 200,
                w: 300,
              },
              {
                t: '300W',
                r: 0,
                c: 'v1/fit/w_300,h_683,q_70,strp/<prettyName>-300w.jpg',
                h: 200,
                w: 300,
              },
              {
                t: '250T',
                r: 0,
                c: 'v1/fill/w_375,h_250,q_70,strp/<prettyName>-250t.jpg',
                h: 250,
                w: 375,
              },
              {
                t: '350T',
                r: 0,
                c: 'v1/fill/w_525,h_350,q_70,strp/<prettyName>-350t.jpg',
                h: 350,
                w: 525,
              },
              {
                t: '400T',
                r: 0,
                c: 'v1/fill/w_600,h_400,q_70,strp/<prettyName>-400t.jpg',
                h: 400,
                w: 600,
              },
              {
                t: 'preview',
                r: 0,
                c: 'v1/fill/w_1024,h_683,q_75,strp/<prettyName>-fullview.jpg',
                h: 683,
                w: 1024,
                f: 6722544,
              },
              {
                t: 'social_preview',
                r: 0,
                c: 'v1/fill/w_1024,h_683,q_75,strp/<prettyName>-fullview.jpg',
                h: 683,
                w: 1024,
              },
              {
                t: 'fullview',
                r: 0,
                c: 'v1/fill/w_1024,h_683,q_75,strp/<prettyName>-fullview.jpg',
                h: 683,
                w: 1024,
                f: 6722544,
              },
            ],
          },
        },
      },
    },
  },
  {
    messageId: 'id:nc:4:18468580:899282422:313707851',
    type: 'nc.deviation_mentions_deviation',
    messageClass: 'class.mention.deviation',
    bucket: 'bucket.mention',
    folderId: 34,
    orphaned: false,
    ts: '2021-12-07T05:20:42-0800',
    isNew: true,
    originator: {
      userId: 18468580,
      useridUuid: '0a8ace1e-a5d0-45cc-94a5-b8630c37fb8a',
      username: 'inazar',
      usericon: 'https://a.deviantart.net/avatars-big/i/n/inazar.png?11',
      type: 'admin',
      isWatching: false,
      isSubscribed: false,
      isNewDeviant: false,
    },
    messageData: {
      dataKey: 'deviation_mentions_deviation',
      deviationMentionsDeviation: {
        mentioner: {
          deviationId: 899282422,
          type: 'status',
          typeId: 81,
          url: 'https://www.deviantart.lan/inazar/status-update/mention-in-a-status-899282422',
          title: 'mention in a status',
          isJournal: false,
          isVideo: false,
          isPurchasable: false,
          isFavouritable: true,
          publishedTime: '2021-12-07T05:20:42-0800',
          isTextEditable: true,
          legacyTextEditUrl: null,
          isShareable: true,
          isCommentable: true,
          isFavourited: false,
          isDeleted: false,
          isMature: false,
          isDownloadable: false,
          isAntisocial: false,
          isBlocked: false,
          isPublished: true,
          isDailyDeviation: false,
          hasPrivateComments: false,
          blockReasons: [],
          author: {
            userId: 18468580,
            useridUuid: '0a8ace1e-a5d0-45cc-94a5-b8630c37fb8a',
            username: 'inazar',
            usericon: 'https://a.deviantart.net/avatars-big/i/n/inazar.png?11',
            type: 'admin',
            isWatching: false,
            isSubscribed: false,
            isNewDeviant: false,
          },
          stats: { comments: 0, favourites: 0 },
          media: { types: [] },
          textContent: {
            excerpt: 'mention in a status post',
            html: {
              type: 'draft',
              features:
                '[{"type":"FIRST_IMAGE_FEATURE","data":{"deviation":{"deviationId":313707851,"type":"image","typeId":1,"url":"https:\\/\\/www.deviantart.lan\\/chris\\/art\\/Pacific-Coast-Highway-Photos-313707851","title":"Pacific Coast Highway Photos","isJournal":false,"isVideo":false,"isPurchasable":true,"isFavouritable":true,"publishedTime":"2012-07-09T19:47:17-0700","isShareable":true,"isCommentable":true,"isFavourited":false,"isDeleted":false,"isMature":false,"isDownloadable":false,"isAntisocial":false,"isBlocked":false,"isPublished":true,"isDailyDeviation":false,"hasPrivateComments":false,"author":{"userId":3,"useridUuid":"178e6afa-0f9b-4ef0-bb15-47dadfa0e470","username":"chris","usericon":"https:\\/\\/a.deviantart.net\\/avatars-big\\/c\\/h\\/chris.jpg?4","type":"admin","isWatching":false,"isSubscribed":false,"isNewDeviant":false},"media":{"baseUri":"https:\\/\\/images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com\\/f\\/178e6afa-0f9b-4ef0-bb15-47dadfa0e470\\/d56ruiz-a65409ce-bc27-454f-bf1c-f9f181973048.jpg","prettyName":"pacific_coast_highway_photos_by_chris_d56ruiz","token":["eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7ImhlaWdodCI6Ijw9NjgzIiwicGF0aCI6IlwvZlwvMTc4ZTZhZmEtMGY5Yi00ZWYwLWJiMTUtNDdkYWRmYTBlNDcwXC9kNTZydWl6LWE2NTQwOWNlLWJjMjctNDU0Zi1iZjFjLWY5ZjE4MTk3MzA0OC5qcGciLCJ3aWR0aCI6Ijw9MTAyNCJ9XV0sImF1ZCI6WyJ1cm46c2VydmljZTppbWFnZS5vcGVyYXRpb25zIl19.d5CXSWMivKwoyOixdI9FJudAThJl2wXV0DdojlmVUXc"],"types":[{"t":"150","r":0,"c":"v1\\/fit\\/w_150,h_150,q_70,strp\\/<prettyName>-150.jpg","h":100,"w":150},{"t":"200H","r":0,"c":"v1\\/fill\\/w_300,h_200,q_70,strp\\/<prettyName>-200h.jpg","h":200,"w":300},{"t":"300W","r":0,"c":"v1\\/fit\\/w_300,h_683,q_70,strp\\/<prettyName>-300w.jpg","h":200,"w":300},{"t":"250T","r":0,"c":"v1\\/fill\\/w_375,h_250,q_70,strp\\/<prettyName>-250t.jpg","h":250,"w":375},{"t":"350T","r":0,"c":"v1\\/fill\\/w_525,h_350,q_70,strp\\/<prettyName>-350t.jpg","h":350,"w":525},{"t":"400T","r":0,"c":"v1\\/fill\\/w_600,h_400,q_70,strp\\/<prettyName>-400t.jpg","h":400,"w":600},{"t":"preview","r":0,"c":"v1\\/fill\\/w_1024,h_683,q_75,strp\\/<prettyName>-fullview.jpg","h":683,"w":1024,"f":6722544},{"t":"social_preview","r":0,"c":"v1\\/fill\\/w_1024,h_683,q_75,strp\\/<prettyName>-fullview.jpg","h":683,"w":1024},{"t":"fullview","r":0,"c":"v1\\/fill\\/w_1024,h_683,q_75,strp\\/<prettyName>-fullview.jpg","h":683,"w":1024,"f":6722544}]}}}},{"type":"IS_EMPTY_FEATURE","data":{"isEmpty":false}},{"type":"MEDIA_COUNT_FEATURE","data":{"emoji":0,"emotes":0,"images":1,"mentions":0,"video":0,"previews":0}},{"type":"WORD_COUNT_FEATURE","data":{"words":5,"chars":27}}]',
            },
          },
        },
        mentioned: {
          deviationId: 313707851,
          type: 'image',
          typeId: 1,
          url: 'https://www.deviantart.lan/chris/art/Pacific-Coast-Highway-Photos-313707851',
          title: 'Pacific Coast Highway Photos',
          isJournal: false,
          isVideo: false,
          isPurchasable: true,
          isFavouritable: false,
          publishedTime: '2012-07-09T19:47:17-0700',
          isTextEditable: false,
          legacyTextEditUrl: null,
          isShareable: true,
          isCommentable: true,
          isFavourited: false,
          isDeleted: false,
          isMature: false,
          isDownloadable: false,
          isAntisocial: false,
          isBlocked: false,
          isPublished: true,
          isDailyDeviation: false,
          hasPrivateComments: false,
          blockReasons: [],
          author: {
            userId: 3,
            useridUuid: '178e6afa-0f9b-4ef0-bb15-47dadfa0e470',
            username: 'chris',
            usericon: 'https://a.deviantart.net/avatars-big/c/h/chris.jpg?4',
            type: 'admin',
            isWatching: false,
            isNewDeviant: false,
          },
          stats: { comments: 0, favourites: 0 },
          media: {
            baseUri:
              'https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/178e6afa-0f9b-4ef0-bb15-47dadfa0e470/d56ruiz-a65409ce-bc27-454f-bf1c-f9f181973048.jpg',
            prettyName: 'pacific_coast_highway_photos_by_chris_d56ruiz',
            token: [
              'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7ImhlaWdodCI6Ijw9NjgzIiwicGF0aCI6IlwvZlwvMTc4ZTZhZmEtMGY5Yi00ZWYwLWJiMTUtNDdkYWRmYTBlNDcwXC9kNTZydWl6LWE2NTQwOWNlLWJjMjctNDU0Zi1iZjFjLWY5ZjE4MTk3MzA0OC5qcGciLCJ3aWR0aCI6Ijw9MTAyNCJ9XV0sImF1ZCI6WyJ1cm46c2VydmljZTppbWFnZS5vcGVyYXRpb25zIl19.d5CXSWMivKwoyOixdI9FJudAThJl2wXV0DdojlmVUXc',
            ],
            types: [
              {
                t: '150',
                r: 0,
                c: 'v1/fit/w_150,h_150,q_70,strp/<prettyName>-150.jpg',
                h: 100,
                w: 150,
              },
              {
                t: '200H',
                r: 0,
                c: 'v1/fill/w_300,h_200,q_70,strp/<prettyName>-200h.jpg',
                h: 200,
                w: 300,
              },
              {
                t: '300W',
                r: 0,
                c: 'v1/fit/w_300,h_683,q_70,strp/<prettyName>-300w.jpg',
                h: 200,
                w: 300,
              },
              {
                t: '250T',
                r: 0,
                c: 'v1/fill/w_375,h_250,q_70,strp/<prettyName>-250t.jpg',
                h: 250,
                w: 375,
              },
              {
                t: '350T',
                r: 0,
                c: 'v1/fill/w_525,h_350,q_70,strp/<prettyName>-350t.jpg',
                h: 350,
                w: 525,
              },
              {
                t: '400T',
                r: 0,
                c: 'v1/fill/w_600,h_400,q_70,strp/<prettyName>-400t.jpg',
                h: 400,
                w: 600,
              },
              {
                t: 'preview',
                r: 0,
                c: 'v1/fill/w_1024,h_683,q_75,strp/<prettyName>-fullview.jpg',
                h: 683,
                w: 1024,
                f: 6722544,
              },
              {
                t: 'social_preview',
                r: 0,
                c: 'v1/fill/w_1024,h_683,q_75,strp/<prettyName>-fullview.jpg',
                h: 683,
                w: 1024,
              },
              {
                t: 'fullview',
                r: 0,
                c: 'v1/fill/w_1024,h_683,q_75,strp/<prettyName>-fullview.jpg',
                h: 683,
                w: 1024,
                f: 6722544,
              },
            ],
          },
        },
      },
    },
  },
  {
    messageId: 'id:nc:6:18468580:4955310269:313707851',
    type: 'nc.comment_mentions_deviation',
    messageClass: 'class.mention.deviation',
    bucket: 'bucket.mention',
    folderId: 34,
    orphaned: false,
    ts: '2021-12-07T05:20:23-0800',
    isNew: true,
    originator: {
      userId: 18468580,
      useridUuid: '0a8ace1e-a5d0-45cc-94a5-b8630c37fb8a',
      username: 'inazar',
      usericon: 'https://a.deviantart.net/avatars-big/i/n/inazar.png?11',
      type: 'admin',
      isWatching: false,
      isSubscribed: false,
      isNewDeviant: false,
    },
    messageData: {
      dataKey: 'comment_mentions_deviation',
      commentMentionsDeviation: {
        mentioner: {
          commentId: 4955310269,
          typeId: 1,
          itemId: 876235801,
          parentId: null,
          posted: '2021-12-07T05:20:23-0800',
          replies: 1,
          likes: 0,
          textContent: {
            excerpt: 'mention \n \nin a status comment',
            html: {
              type: 'draft',
              markup:
                '{"blocks":[{"key":"1d28j","text":"mention ","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}},{"key":"567hj","text":" ","type":"atomic","depth":0,"inlineStyleRanges":[],"entityRanges":[{"offset":0,"length":1,"key":0}],"data":{}},{"key":"9gvbi","text":"in a status comment","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}}],"entityMap":{"0":{"type":"wix-draft-plugin-image","mutability":"IMMUTABLE","data":{"config":{"alignment":"center","size":"content","showTitle":true,"showDescription":true,"key":"567hj"},"data":{"deviationId":313707851,"type":"image","typeId":1,"url":"https://www.deviantart.lan/chris/art/Pacific-Coast-Highway-Photos-313707851","title":"Pacific Coast Highway Photos","isJournal":false,"isVideo":false,"isPurchasable":true,"isFavouritable":true,"publishedTime":"2012-07-09T19:47:17-0700","isShareable":true,"isCommentable":true,"isFavourited":false,"isDeleted":false,"isMature":false,"isDownloadable":false,"isAntisocial":false,"isBlocked":false,"isPublished":true,"isDailyDeviation":false,"hasPrivateComments":false,"author":{"userId":3,"useridUuid":"178e6afa-0f9b-4ef0-bb15-47dadfa0e470","username":"chris","usericon":"https://a.deviantart.net/avatars-big/c/h/chris.jpg?4","type":"admin","isWatching":false,"isSubscribed":false,"isNewDeviant":false},"media":{"baseUri":"https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/178e6afa-0f9b-4ef0-bb15-47dadfa0e470/d56ruiz-a65409ce-bc27-454f-bf1c-f9f181973048.jpg","prettyName":"pacific_coast_highway_photos_by_chris_d56ruiz","token":["eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7ImhlaWdodCI6Ijw9NjgzIiwicGF0aCI6IlwvZlwvMTc4ZTZhZmEtMGY5Yi00ZWYwLWJiMTUtNDdkYWRmYTBlNDcwXC9kNTZydWl6LWE2NTQwOWNlLWJjMjctNDU0Zi1iZjFjLWY5ZjE4MTk3MzA0OC5qcGciLCJ3aWR0aCI6Ijw9MTAyNCJ9XV0sImF1ZCI6WyJ1cm46c2VydmljZTppbWFnZS5vcGVyYXRpb25zIl19.d5CXSWMivKwoyOixdI9FJudAThJl2wXV0DdojlmVUXc"],"types":[{"t":"150","r":0,"c":"v1/fit/w_150,h_150,q_70,strp/<prettyName>-150.jpg","h":100,"w":150},{"t":"200H","r":0,"c":"v1/fill/w_300,h_200,q_70,strp/<prettyName>-200h.jpg","h":200,"w":300},{"t":"300W","r":0,"c":"v1/fit/w_300,h_683,q_70,strp/<prettyName>-300w.jpg","h":200,"w":300},{"t":"250T","r":0,"c":"v1/fill/w_375,h_250,q_70,strp/<prettyName>-250t.jpg","h":250,"w":375},{"t":"350T","r":0,"c":"v1/fill/w_525,h_350,q_70,strp/<prettyName>-350t.jpg","h":350,"w":525},{"t":"400T","r":0,"c":"v1/fill/w_600,h_400,q_70,strp/<prettyName>-400t.jpg","h":400,"w":600},{"t":"preview","r":0,"c":"v1/fill/w_1024,h_683,q_75,strp/<prettyName>-fullview.jpg","h":683,"w":1024,"f":6722544},{"t":"social_preview","r":0,"c":"v1/fill/w_1024,h_683,q_75,strp/<prettyName>-fullview.jpg","h":683,"w":1024},{"t":"fullview","r":0,"c":"v1/fill/w_1024,h_683,q_75,strp/<prettyName>-fullview.jpg","h":683,"w":1024,"f":6722544}]}}}}}}',
              features:
                '[{"type":"FIRST_IMAGE_FEATURE","data":{"deviation":{"deviationId":313707851,"type":"image","typeId":1,"url":"https:\\/\\/www.deviantart.lan\\/chris\\/art\\/Pacific-Coast-Highway-Photos-313707851","title":"Pacific Coast Highway Photos","isJournal":false,"isVideo":false,"isPurchasable":true,"isFavouritable":true,"publishedTime":"2012-07-09T19:47:17-0700","isShareable":true,"isCommentable":true,"isFavourited":false,"isDeleted":false,"isMature":false,"isDownloadable":false,"isAntisocial":false,"isBlocked":false,"isPublished":true,"isDailyDeviation":false,"hasPrivateComments":false,"author":{"userId":3,"useridUuid":"178e6afa-0f9b-4ef0-bb15-47dadfa0e470","username":"chris","usericon":"https:\\/\\/a.deviantart.net\\/avatars-big\\/c\\/h\\/chris.jpg?4","type":"admin","isWatching":false,"isSubscribed":false,"isNewDeviant":false},"media":{"baseUri":"https:\\/\\/images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com\\/f\\/178e6afa-0f9b-4ef0-bb15-47dadfa0e470\\/d56ruiz-a65409ce-bc27-454f-bf1c-f9f181973048.jpg","prettyName":"pacific_coast_highway_photos_by_chris_d56ruiz","token":["eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7ImhlaWdodCI6Ijw9NjgzIiwicGF0aCI6IlwvZlwvMTc4ZTZhZmEtMGY5Yi00ZWYwLWJiMTUtNDdkYWRmYTBlNDcwXC9kNTZydWl6LWE2NTQwOWNlLWJjMjctNDU0Zi1iZjFjLWY5ZjE4MTk3MzA0OC5qcGciLCJ3aWR0aCI6Ijw9MTAyNCJ9XV0sImF1ZCI6WyJ1cm46c2VydmljZTppbWFnZS5vcGVyYXRpb25zIl19.d5CXSWMivKwoyOixdI9FJudAThJl2wXV0DdojlmVUXc"],"types":[{"t":"150","r":0,"c":"v1\\/fit\\/w_150,h_150,q_70,strp\\/<prettyName>-150.jpg","h":100,"w":150},{"t":"200H","r":0,"c":"v1\\/fill\\/w_300,h_200,q_70,strp\\/<prettyName>-200h.jpg","h":200,"w":300},{"t":"300W","r":0,"c":"v1\\/fit\\/w_300,h_683,q_70,strp\\/<prettyName>-300w.jpg","h":200,"w":300},{"t":"250T","r":0,"c":"v1\\/fill\\/w_375,h_250,q_70,strp\\/<prettyName>-250t.jpg","h":250,"w":375},{"t":"350T","r":0,"c":"v1\\/fill\\/w_525,h_350,q_70,strp\\/<prettyName>-350t.jpg","h":350,"w":525},{"t":"400T","r":0,"c":"v1\\/fill\\/w_600,h_400,q_70,strp\\/<prettyName>-400t.jpg","h":400,"w":600},{"t":"preview","r":0,"c":"v1\\/fill\\/w_1024,h_683,q_75,strp\\/<prettyName>-fullview.jpg","h":683,"w":1024,"f":6722544},{"t":"social_preview","r":0,"c":"v1\\/fill\\/w_1024,h_683,q_75,strp\\/<prettyName>-fullview.jpg","h":683,"w":1024},{"t":"fullview","r":0,"c":"v1\\/fill\\/w_1024,h_683,q_75,strp\\/<prettyName>-fullview.jpg","h":683,"w":1024,"f":6722544}]}}}},{"type":"IS_EMPTY_FEATURE","data":{"isEmpty":false}},{"type":"MEDIA_COUNT_FEATURE","data":{"emoji":0,"emotes":0,"images":1,"mentions":0,"video":0,"previews":0}},{"type":"WORD_COUNT_FEATURE","data":{"words":5,"chars":28}}]',
            },
          },
          user: {
            userId: 18468580,
            useridUuid: '0a8ace1e-a5d0-45cc-94a5-b8630c37fb8a',
            username: 'inazar',
            usericon: 'https://a.deviantart.net/avatars-big/i/n/inazar.png?11',
            type: 'admin',
            isWatching: false,
            isSubscribed: false,
            isNewDeviant: false,
          },
          commentUrl: 'https://www.deviantart.lan/comments/1/876235801/4955310269',
          commentable: {
            dataKey: 'deviation',
            deviation: {
              deviationId: 876235801,
              type: 'status',
              typeId: 81,
              url: 'https://www.deviantart.lan/justgalym/status-update/What-s-your-favourite-character-in-876235801',
              title: "What's your favourite character in",
              isJournal: false,
              isVideo: false,
              isPurchasable: false,
              isFavouritable: true,
              publishedTime: '2021-04-13T02:44:19-0700',
              isTextEditable: true,
              legacyTextEditUrl: null,
              isShareable: true,
              isCommentable: true,
              isFavourited: false,
              isDeleted: false,
              isMature: false,
              isDownloadable: false,
              isAntisocial: false,
              isBlocked: false,
              isPublished: true,
              isDailyDeviation: false,
              hasPrivateComments: false,
              blockReasons: [],
              author: {
                userId: 26498960,
                useridUuid: 'c086444e-69b0-4fad-8e80-e5613abb5d19',
                username: 'justgalym',
                usericon: 'https://a.deviantart.net/avatars-big/j/u/justgalym.jpg?4',
                type: 'admin',
                isWatching: false,
                isSubscribed: false,
                isNewDeviant: false,
              },
              stats: { comments: 0, favourites: 0 },
              media: { types: [] },
              textContent: {
                excerpt: "What's your favourite character in GoT?",
                html: {
                  type: 'draft',
                  features:
                    '[{"type":"FIRST_IMAGE_FEATURE","data":[]},{"type":"IS_EMPTY_FEATURE","data":{"isEmpty":false}},{"type":"MEDIA_COUNT_FEATURE","data":{"emotes":0,"images":0,"mentions":0,"video":0}},{"type":"WORD_COUNT_FEATURE","data":{"words":6,"chars":39}}]',
                },
              },
            },
          },
        },
        mentioned: {
          deviationId: 313707851,
          type: 'image',
          typeId: 1,
          url: 'https://www.deviantart.lan/chris/art/Pacific-Coast-Highway-Photos-313707851',
          title: 'Pacific Coast Highway Photos',
          isJournal: false,
          isVideo: false,
          isPurchasable: true,
          isFavouritable: false,
          publishedTime: '2012-07-09T19:47:17-0700',
          isTextEditable: false,
          legacyTextEditUrl: null,
          isShareable: true,
          isCommentable: true,
          isFavourited: false,
          isDeleted: false,
          isMature: false,
          isDownloadable: false,
          isAntisocial: false,
          isBlocked: false,
          isPublished: true,
          isDailyDeviation: false,
          hasPrivateComments: false,
          blockReasons: [],
          author: {
            userId: 3,
            useridUuid: '178e6afa-0f9b-4ef0-bb15-47dadfa0e470',
            username: 'chris',
            usericon: 'https://a.deviantart.net/avatars-big/c/h/chris.jpg?4',
            type: 'admin',
            isWatching: false,
            isNewDeviant: false,
          },
          stats: { comments: 0, favourites: 0 },
          media: {
            baseUri:
              'https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/178e6afa-0f9b-4ef0-bb15-47dadfa0e470/d56ruiz-a65409ce-bc27-454f-bf1c-f9f181973048.jpg',
            prettyName: 'pacific_coast_highway_photos_by_chris_d56ruiz',
            token: [
              'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7ImhlaWdodCI6Ijw9NjgzIiwicGF0aCI6IlwvZlwvMTc4ZTZhZmEtMGY5Yi00ZWYwLWJiMTUtNDdkYWRmYTBlNDcwXC9kNTZydWl6LWE2NTQwOWNlLWJjMjctNDU0Zi1iZjFjLWY5ZjE4MTk3MzA0OC5qcGciLCJ3aWR0aCI6Ijw9MTAyNCJ9XV0sImF1ZCI6WyJ1cm46c2VydmljZTppbWFnZS5vcGVyYXRpb25zIl19.d5CXSWMivKwoyOixdI9FJudAThJl2wXV0DdojlmVUXc',
            ],
            types: [
              {
                t: '150',
                r: 0,
                c: 'v1/fit/w_150,h_150,q_70,strp/<prettyName>-150.jpg',
                h: 100,
                w: 150,
              },
              {
                t: '200H',
                r: 0,
                c: 'v1/fill/w_300,h_200,q_70,strp/<prettyName>-200h.jpg',
                h: 200,
                w: 300,
              },
              {
                t: '300W',
                r: 0,
                c: 'v1/fit/w_300,h_683,q_70,strp/<prettyName>-300w.jpg',
                h: 200,
                w: 300,
              },
              {
                t: '250T',
                r: 0,
                c: 'v1/fill/w_375,h_250,q_70,strp/<prettyName>-250t.jpg',
                h: 250,
                w: 375,
              },
              {
                t: '350T',
                r: 0,
                c: 'v1/fill/w_525,h_350,q_70,strp/<prettyName>-350t.jpg',
                h: 350,
                w: 525,
              },
              {
                t: '400T',
                r: 0,
                c: 'v1/fill/w_600,h_400,q_70,strp/<prettyName>-400t.jpg',
                h: 400,
                w: 600,
              },
              {
                t: 'preview',
                r: 0,
                c: 'v1/fill/w_1024,h_683,q_75,strp/<prettyName>-fullview.jpg',
                h: 683,
                w: 1024,
                f: 6722544,
              },
              {
                t: 'social_preview',
                r: 0,
                c: 'v1/fill/w_1024,h_683,q_75,strp/<prettyName>-fullview.jpg',
                h: 683,
                w: 1024,
              },
              {
                t: 'fullview',
                r: 0,
                c: 'v1/fill/w_1024,h_683,q_75,strp/<prettyName>-fullview.jpg',
                h: 683,
                w: 1024,
                f: 6722544,
              },
            ],
          },
        },
      },
    },
  },
  {
    messageId: 'id:nc:7:18468580:4955310268:0',
    type: 'nc.comment_mentions_user',
    messageClass: 'class.mention.user',
    bucket: 'bucket.mention',
    folderId: 34,
    orphaned: false,
    ts: '2021-12-07T05:19:40-0800',
    isNew: true,
    originator: {
      userId: 18468580,
      useridUuid: '0a8ace1e-a5d0-45cc-94a5-b8630c37fb8a',
      username: 'inazar',
      usericon: 'https://a.deviantart.net/avatars-big/i/n/inazar.png?11',
      type: 'admin',
      isWatching: false,
      isSubscribed: false,
      isNewDeviant: false,
    },
    messageData: {
      dataKey: 'comment_mentions_user',
      commentMentionsUser: {
        mentioner: {
          commentId: 4955310268,
          typeId: 1,
          itemId: 876235801,
          parentId: null,
          posted: '2021-12-07T05:19:40-0800',
          replies: 1,
          likes: 0,
          textContent: {
            excerpt: 'Mention @chris in a status comment',
            html: {
              type: 'draft',
              markup:
                '{"blocks":[{"key":"foo","text":"Mention @chris in a status comment","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[{"offset":8,"length":6,"key":0}],"data":{}}],"entityMap":{"0":{"type":"mention","mutability":"IMMUTABLE","data":{"mention":{"name":"chris","avatar":"https://a.deviantart.net/avatars-big/c/h/chris.jpg?4","type":"admin","userId":3}}}}}',
              features:
                '[{"type":"FIRST_IMAGE_FEATURE","data":[]},{"type":"IS_EMPTY_FEATURE","data":{"isEmpty":false}},{"type":"MEDIA_COUNT_FEATURE","data":{"emoji":0,"emotes":0,"images":0,"mentions":1,"video":0,"previews":0}},{"type":"WORD_COUNT_FEATURE","data":{"words":6,"chars":34}}]',
            },
          },
          user: {
            userId: 18468580,
            useridUuid: '0a8ace1e-a5d0-45cc-94a5-b8630c37fb8a',
            username: 'inazar',
            usericon: 'https://a.deviantart.net/avatars-big/i/n/inazar.png?11',
            type: 'admin',
            isWatching: false,
            isSubscribed: false,
            isNewDeviant: false,
          },
          commentUrl: 'https://www.deviantart.lan/comments/1/876235801/4955310268',
          commentable: {
            dataKey: 'deviation',
            deviation: {
              deviationId: 876235801,
              type: 'status',
              typeId: 81,
              url: 'https://www.deviantart.lan/justgalym/status-update/What-s-your-favourite-character-in-876235801',
              title: "What's your favourite character in",
              isJournal: false,
              isVideo: false,
              isPurchasable: false,
              isFavouritable: true,
              publishedTime: '2021-04-13T02:44:19-0700',
              isTextEditable: true,
              legacyTextEditUrl: null,
              isShareable: true,
              isCommentable: true,
              isFavourited: false,
              isDeleted: false,
              isMature: false,
              isDownloadable: false,
              isAntisocial: false,
              isBlocked: false,
              isPublished: true,
              isDailyDeviation: false,
              hasPrivateComments: false,
              blockReasons: [],
              author: {
                userId: 26498960,
                useridUuid: 'c086444e-69b0-4fad-8e80-e5613abb5d19',
                username: 'justgalym',
                usericon: 'https://a.deviantart.net/avatars-big/j/u/justgalym.jpg?4',
                type: 'admin',
                isWatching: false,
                isSubscribed: false,
                isNewDeviant: false,
              },
              stats: { comments: 0, favourites: 0 },
              media: { types: [] },
              textContent: {
                excerpt: "What's your favourite character in GoT?",
                html: {
                  type: 'draft',
                  features:
                    '[{"type":"FIRST_IMAGE_FEATURE","data":[]},{"type":"IS_EMPTY_FEATURE","data":{"isEmpty":false}},{"type":"MEDIA_COUNT_FEATURE","data":{"emotes":0,"images":0,"mentions":0,"video":0}},{"type":"WORD_COUNT_FEATURE","data":{"words":6,"chars":39}}]',
                },
              },
            },
          },
        },
      },
    },
  },
  {
    messageId: 'id:nc:7:18468580:4955310267:0',
    type: 'nc.comment_mentions_user',
    messageClass: 'class.mention.user',
    bucket: 'bucket.mention',
    folderId: 34,
    orphaned: false,
    ts: '2021-12-07T05:03:08-0800',
    isNew: false,
    originator: {
      userId: 18468580,
      useridUuid: '0a8ace1e-a5d0-45cc-94a5-b8630c37fb8a',
      username: 'inazar',
      usericon: 'https://a.deviantart.net/avatars-big/i/n/inazar.png?11',
      type: 'admin',
      isWatching: false,
      isSubscribed: false,
      isNewDeviant: false,
    },
    messageData: {
      dataKey: 'comment_mentions_user',
      commentMentionsUser: {
        mentioner: {
          commentId: 4955310267,
          typeId: 1,
          itemId: 883924185,
          parentId: null,
          posted: '2021-12-07T05:03:08-0800',
          replies: 1,
          likes: 0,
          textContent: {
            excerpt: 'Mention @chris on a normal deviation',
            html: {
              type: 'draft',
              markup:
                '{"blocks":[{"key":"foo","text":"Mention @chris on a normal deviation","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[{"offset":8,"length":6,"key":0}],"data":{}}],"entityMap":{"0":{"type":"mention","mutability":"IMMUTABLE","data":{"mention":{"name":"chris","avatar":"https://a.deviantart.net/avatars-big/c/h/chris.jpg?4","type":"admin","userId":3}}}}}',
              features:
                '[{"type":"FIRST_IMAGE_FEATURE","data":[]},{"type":"IS_EMPTY_FEATURE","data":{"isEmpty":false}},{"type":"MEDIA_COUNT_FEATURE","data":{"emoji":0,"emotes":0,"images":0,"mentions":1,"video":0,"previews":0}},{"type":"WORD_COUNT_FEATURE","data":{"words":6,"chars":36}}]',
            },
          },
          user: {
            userId: 18468580,
            useridUuid: '0a8ace1e-a5d0-45cc-94a5-b8630c37fb8a',
            username: 'inazar',
            usericon: 'https://a.deviantart.net/avatars-big/i/n/inazar.png?11',
            type: 'admin',
            isWatching: false,
            isSubscribed: false,
            isNewDeviant: false,
          },
          commentUrl: 'https://www.deviantart.lan/comments/1/883924185/4955310267',
          commentable: {
            dataKey: 'deviation',
            deviation: {
              deviationId: 883924185,
              type: 'image',
              typeId: 1,
              url: 'https://www.deviantart.lan/inazar/art/Kenopsia-883924185',
              title: 'Kenopsia',
              isJournal: false,
              isVideo: false,
              isPurchasable: false,
              isFavouritable: true,
              publishedTime: '2021-06-27T08:01:39-0700',
              isTextEditable: false,
              legacyTextEditUrl: null,
              isShareable: true,
              isCommentable: true,
              isFavourited: false,
              isDeleted: false,
              isMature: false,
              isDownloadable: true,
              isAntisocial: false,
              isBlocked: false,
              isPublished: true,
              isDailyDeviation: false,
              hasPrivateComments: false,
              blockReasons: [],
              author: {
                userId: 18468580,
                useridUuid: '0a8ace1e-a5d0-45cc-94a5-b8630c37fb8a',
                username: 'inazar',
                usericon: 'https://a.deviantart.net/avatars-big/i/n/inazar.png?11',
                type: 'admin',
                isWatching: false,
                isSubscribed: false,
                isNewDeviant: false,
              },
              stats: { comments: 0, favourites: 0 },
              media: {
                baseUri:
                  'https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/0a8ace1e-a5d0-45cc-94a5-b8630c37fb8a/dem9k9l-fb6f4e04-3bd0-41fa-92a1-e18b7e7c6b9c.jpg',
                prettyName: 'kenopsia_by_inazar_dem9k9l',
                token: [
                  'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7ImhlaWdodCI6Ijw9OTYwIiwicGF0aCI6IlwvZlwvMGE4YWNlMWUtYTVkMC00NWNjLTk0YTUtYjg2MzBjMzdmYjhhXC9kZW05azlsLWZiNmY0ZTA0LTNiZDAtNDFmYS05MmExLWUxOGI3ZTdjNmI5Yy5qcGciLCJ3aWR0aCI6Ijw9MTI4MCJ9XV0sImF1ZCI6WyJ1cm46c2VydmljZTppbWFnZS5vcGVyYXRpb25zIl19.OBAa88EjmRC4T2kTBNgnt6BbW5GyiGXZUXD4G8Z1Xuc',
                ],
                types: [
                  {
                    t: '150',
                    r: 0,
                    c: 'v1/fit/w_150,h_150,q_70,strp/<prettyName>-150.jpg',
                    h: 113,
                    w: 150,
                  },
                  {
                    t: '200H',
                    r: 0,
                    c: 'v1/fill/w_267,h_200,q_70,strp/<prettyName>-200h.jpg',
                    h: 200,
                    w: 267,
                  },
                  {
                    t: '300W',
                    r: 0,
                    c: 'v1/fit/w_300,h_900,q_70,strp/<prettyName>-300w.jpg',
                    h: 225,
                    w: 300,
                  },
                  {
                    t: '250T',
                    r: 0,
                    c: 'v1/fill/w_333,h_250,q_70,strp/<prettyName>-250t.jpg',
                    h: 250,
                    w: 333,
                  },
                  {
                    t: '350T',
                    r: 0,
                    c: 'v1/fill/w_467,h_350,q_70,strp/<prettyName>-350t.jpg',
                    h: 350,
                    w: 467,
                  },
                  {
                    t: '400T',
                    r: 0,
                    c: 'v1/fill/w_533,h_400,q_70,strp/<prettyName>-400t.jpg',
                    h: 400,
                    w: 533,
                  },
                  {
                    t: 'preview',
                    r: 0,
                    c: 'v1/fill/w_1032,h_774,q_70,strp/<prettyName>-pre.jpg',
                    h: 774,
                    w: 1032,
                    f: 1239693,
                  },
                  {
                    t: 'social_preview',
                    r: 0,
                    c: 'v1/fill/w_1032,h_774,q_70,strp/<prettyName>-pre.jpg',
                    h: 774,
                    w: 1032,
                  },
                  {
                    t: 'fullview',
                    r: 0,
                    c: 'v1/fill/w_1280,h_960,q_75,strp/<prettyName>-fullview.jpg',
                    h: 960,
                    w: 1280,
                    f: 1239693,
                  },
                ],
              },
            },
          },
        },
      },
    },
  },
  {
    messageId: 'id:nc:5:18468580:899282421:0',
    type: 'nc.deviation_mentions_user',
    messageClass: 'class.mention.user',
    bucket: 'bucket.mention',
    folderId: 34,
    orphaned: false,
    ts: '2021-12-07T05:02:11-0800',
    isNew: false,
    originator: {
      userId: 18468580,
      useridUuid: '0a8ace1e-a5d0-45cc-94a5-b8630c37fb8a',
      username: 'inazar',
      usericon: 'https://a.deviantart.net/avatars-big/i/n/inazar.png?11',
      type: 'admin',
      isWatching: false,
      isSubscribed: false,
      isNewDeviant: false,
    },
    messageData: {
      dataKey: 'deviation_mentions_user',
      deviationMentionsUser: {
        mentioner: {
          deviationId: 899282421,
          type: 'status',
          typeId: 81,
          url: 'https://www.deviantart.lan/inazar/status-update/mention-chris-in-a-status-899282421',
          title: 'mention @chris in a status',
          isJournal: false,
          isVideo: false,
          isPurchasable: false,
          isFavouritable: true,
          publishedTime: '2021-12-07T05:02:11-0800',
          isTextEditable: true,
          legacyTextEditUrl: null,
          isShareable: true,
          isCommentable: true,
          isFavourited: false,
          isDeleted: false,
          isMature: false,
          isDownloadable: false,
          isAntisocial: false,
          isBlocked: false,
          isPublished: true,
          isDailyDeviation: false,
          hasPrivateComments: false,
          blockReasons: [],
          author: {
            userId: 18468580,
            useridUuid: '0a8ace1e-a5d0-45cc-94a5-b8630c37fb8a',
            username: 'inazar',
            usericon: 'https://a.deviantart.net/avatars-big/i/n/inazar.png?11',
            type: 'admin',
            isWatching: false,
            isSubscribed: false,
            isNewDeviant: false,
          },
          stats: { comments: 0, favourites: 0 },
          media: { types: [] },
          textContent: {
            excerpt: 'mention @chris in a status',
            html: {
              type: 'draft',
              features:
                '[{"type":"FIRST_IMAGE_FEATURE","data":[]},{"type":"IS_EMPTY_FEATURE","data":{"isEmpty":false}},{"type":"MEDIA_COUNT_FEATURE","data":{"emoji":0,"emotes":0,"images":0,"mentions":1,"video":0,"previews":0}},{"type":"WORD_COUNT_FEATURE","data":{"words":5,"chars":26}}]',
            },
          },
        },
      },
    },
  },
  {
    messageId: 'id:nc:7:18468580:4955310265:0',
    type: 'nc.comment_mentions_user',
    messageClass: 'class.mention.user',
    bucket: 'bucket.mention',
    folderId: 34,
    orphaned: false,
    ts: '2021-12-07T05:01:34-0800',
    isNew: false,
    originator: {
      userId: 18468580,
      useridUuid: '0a8ace1e-a5d0-45cc-94a5-b8630c37fb8a',
      username: 'inazar',
      usericon: 'https://a.deviantart.net/avatars-big/i/n/inazar.png?11',
      type: 'admin',
      isWatching: false,
      isSubscribed: false,
      isNewDeviant: false,
    },
    messageData: {
      dataKey: 'comment_mentions_user',
      commentMentionsUser: {
        mentioner: {
          commentId: 4955310265,
          typeId: 1,
          itemId: 881239537,
          parentId: null,
          posted: '2021-12-07T05:01:34-0800',
          replies: 1,
          likes: 0,
          textContent: {
            excerpt: 'mention @chris again',
            html: {
              type: 'draft',
              markup:
                '{"blocks":[{"key":"b85a5","text":"mention @chris again","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[{"offset":8,"length":6,"key":0}],"data":{}}],"entityMap":{"0":{"type":"mention","mutability":"IMMUTABLE","data":{"mention":{"name":"chris","avatar":"https://a.deviantart.net/avatars-big/c/h/chris.jpg?4","type":"admin","userId":3}}}}}',
              features:
                '[{"type":"FIRST_IMAGE_FEATURE","data":[]},{"type":"IS_EMPTY_FEATURE","data":{"isEmpty":false}},{"type":"MEDIA_COUNT_FEATURE","data":{"emoji":0,"emotes":0,"images":0,"mentions":1,"video":0,"previews":0}},{"type":"WORD_COUNT_FEATURE","data":{"words":3,"chars":20}}]',
            },
          },
          user: {
            userId: 18468580,
            useridUuid: '0a8ace1e-a5d0-45cc-94a5-b8630c37fb8a',
            username: 'inazar',
            usericon: 'https://a.deviantart.net/avatars-big/i/n/inazar.png?11',
            type: 'admin',
            isWatching: false,
            isSubscribed: false,
            isNewDeviant: false,
          },
          commentUrl: 'https://www.deviantart.lan/comments/1/881239537/4955310265',
          commentable: {
            dataKey: 'deviation',
            deviation: {
              deviationId: 881239537,
              type: 'journal',
              typeId: 5,
              url: 'https://www.deviantart.lan/inazar/journal/Anti-Cheat-Countermeasures-in-the-Holiday-Puzzle-881239537',
              title: 'Anti-Cheat Countermeasures in the Holiday Puzzle',
              isJournal: true,
              isVideo: false,
              isPurchasable: false,
              isFavouritable: true,
              publishedTime: '2021-06-09T12:09:21-0700',
              isTextEditable: true,
              legacyTextEditUrl: null,
              isShareable: true,
              isCommentable: true,
              isFavourited: false,
              isDeleted: false,
              isMature: false,
              isDownloadable: false,
              isAntisocial: false,
              isBlocked: false,
              isPublished: true,
              isDailyDeviation: false,
              hasPrivateComments: false,
              blockReasons: [],
              author: {
                userId: 18468580,
                useridUuid: '0a8ace1e-a5d0-45cc-94a5-b8630c37fb8a',
                username: 'inazar',
                usericon: 'https://a.deviantart.net/avatars-big/i/n/inazar.png?11',
                type: 'admin',
                isWatching: false,
                isSubscribed: false,
                isNewDeviant: false,
              },
              stats: { comments: 0, favourites: 0 },
              media: { types: [] },
              textContent: {
                excerpt:
                  'The following information has been declassified from the DeviantArt Code Archive, after the decommissioning of the Holiday Puzzle. Back in the mists of time (or "2011") DA\'s annual Holiday Extravaganza sale needed a little sprucing up, so we came up with the idea of a simple Threes-alike puzzle game: click on groups of three or more Christmas-themed items, and they\'d clear from the screen. Clear as much as you could, and the screen would refill as you moved up a level; cross a threshold with your final score, and get a discount code to use in the shop against prints and DevWear (yes, we once had merch too). As it turned out, the promise of a discount brought out some of the more devious deviants, and they started finding ways to get at the codes without going to the trouble of playing the game... Countermeasure I: Server-side Vouchers Very quickly we found out that an enterprising person, learning that this game provided discount codes, could simply read through the source code of',
                html: {
                  type: 'draft',
                  features:
                    '[{"type":"IS_EMPTY_FEATURE","data":{"isEmpty":false}},{"type":"WORD_COUNT_FEATURE","data":{"words":171,"chars":997}},{"type":"MEDIA_COUNT_FEATURE","data":{"emoji":0,"emotes":0,"images":3,"mentions":0,"video":0,"previews":0}}]',
                },
              },
            },
          },
        },
      },
    },
  },
  {
    messageId: 'id:nc:7:18468580:4955310263:0',
    type: 'nc.comment_mentions_user',
    messageClass: 'class.mention.user',
    bucket: 'bucket.mention',
    folderId: 34,
    orphaned: false,
    ts: '2021-12-07T04:56:21-0800',
    isNew: false,
    originator: {
      userId: 18468580,
      useridUuid: '0a8ace1e-a5d0-45cc-94a5-b8630c37fb8a',
      username: 'inazar',
      usericon: 'https://a.deviantart.net/avatars-big/i/n/inazar.png?11',
      type: 'admin',
      isWatching: false,
      isSubscribed: false,
      isNewDeviant: false,
    },
    messageData: {
      dataKey: 'comment_mentions_user',
      commentMentionsUser: {
        mentioner: {
          commentId: 4955310263,
          typeId: 4,
          itemId: 188081,
          parentId: null,
          posted: '2021-12-07T04:56:21-0800',
          replies: 1,
          likes: 0,
          textContent: {
            excerpt: 'hey chris whats going on',
            html: {
              type: 'writer',
              markup:
                'hey <span class="username-with-symbol u"><a class="u admin username" href="https://www.deviantart.lan/chris" target="_self">chris</a><span class="user-symbol admin" data-quicktip-text="DeviantArt Staff" data-show-tooltip="1" data-gruser-type="admin"></span></span> whats going on',
              features: '',
            },
          },
          user: {
            userId: 18468580,
            useridUuid: '0a8ace1e-a5d0-45cc-94a5-b8630c37fb8a',
            username: 'inazar',
            usericon: 'https://a.deviantart.net/avatars-big/i/n/inazar.png?11',
            type: 'admin',
            isWatching: false,
            isSubscribed: false,
            isNewDeviant: false,
          },
          commentUrl: 'https://www.deviantart.lan/comments/4/188081/4955310263',
          commentable: {
            dataKey: 'profile',
            profile: {
              userId: 188081,
              useridUuid: '6c2295d7-5cca-4eb3-8630-19bdda967396',
              username: 'dt',
              usericon: 'https://a.deviantart.net/avatars-big/d/t/dt.png?3',
              type: 'super group',
              isWatching: true,
              isSubscribed: false,
              isNewDeviant: false,
            },
          },
        },
      },
    },
  },
  {
    messageId: 'id:nc:30:3:41817947:0',
    type: 'nc.points_transaction',
    messageClass: 'class.gift',
    bucket: 'bucket.transaction',
    folderId: 9673,
    orphaned: false,
    ts: '2021-12-09T01:13:30-0800',
    isNew: true,
    originator: {
      userId: 3,
      useridUuid: '178e6afa-0f9b-4ef0-bb15-47dadfa0e470',
      username: 'chris',
      usericon: 'https://a.deviantart.net/avatars-big/c/h/chris.jpg?4',
      type: 'admin',
      isWatching: false,
      isSubscribed: false,
      isNewDeviant: false,
    },
    messageData: {
      dataKey: 'points_transaction',
      pointsTransaction: {
        points: 20,
        memoPreview: 'Giving some points on VM',
      },
    },
  },
  {
    messageId: 'id:nc:30:3:41817947:0',
    type: 'nc.points_transaction',
    messageClass: 'class.gift',
    bucket: 'bucket.transaction',
    folderId: 9673,
    orphaned: false,
    ts: '2021-12-09T01:13:30-0800',
    isNew: true,
    originator: {
      userId: 3,
      useridUuid: '178e6afa-0f9b-4ef0-bb15-47dadfa0e470',
      username: 'chris',
      usericon: 'https://a.deviantart.net/avatars-big/c/h/chris.jpg?4',
      type: 'admin',
      isWatching: false,
      isSubscribed: false,
      isNewDeviant: false,
    },
    messageData: {
      dataKey: 'points_transaction',
      pointsTransaction: {
        points: 30,
        memoPreview: '',
      },
    },
  },
];

export default messages;
